import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  // fetchSingleReview: ['postSlug', 'timeStamp'],
  fetchSingleReview: ['postSlug'],
  fetchSingleReviewStart: null,
  fetchSingleReviewSuccess: ['singleReview'],
  fetchSingleReviewFailure: null,

  fetchRelatedArticlesForSingleReview: ['tagId', 'postId'],
  fetchRelatedArticlesForSingleReviewStart: null,
  fetchRelatedArticlesForSingleReviewSuccess: ['relatedArticles'],
  fetchRelatedArticlesForSingleReviewFailure: null
});

export { Types, Creators };
